import { render, staticRenderFns } from "./StockListDeliveryNotes.vue?vue&type=template&id=a1c0d4fc&scoped=true"
import script from "./StockListDeliveryNotes.vue?vue&type=script&lang=js"
export * from "./StockListDeliveryNotes.vue?vue&type=script&lang=js"
import style0 from "./StockListDeliveryNotes.vue?vue&type=style&index=0&id=a1c0d4fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1c0d4fc",
  null
  
)

export default component.exports